// plugins/ask-ai-events.client.ts

import type { AgentEventDetail } from '~/types/ask-ai';

export default defineNuxtPlugin((nuxtApp) => {
  let areListenersInitialized = false;

  const initAskAIListeners = () => {
    if (areListenersInitialized) {
      return;
    }
    areListenersInitialized = true;

    const eventsToHook = ['google-agent-open-changed', 'google-agent-single-item-clicked', 'google-agent-user-input-entered', 'google-agent-loaded'];

    eventsToHook.forEach((eventName) => {
      window.addEventListener(eventName, (event: CustomEvent<AgentEventDetail>) => {
        const hookName = `ask-ai:${eventName}`;
        try {
          nuxtApp.callHook(hookName, event.detail);
        } catch (error) {
          console.error(`Error calling Nuxt hook '${hookName}':`, error);
        }
      });
    });
  };

  return {
    provide: {
      initAskAIListeners,
    },
  };
});
